import { parseAppEnv } from '@hive/shared';

/** The app's Supabase settings from the repo-root .env, checked once at startup. */
export const appEnv = parseAppEnv(import.meta.env);
